  import React, { createContext, useState, useContext, useCallback, useMemo, useEffect } from "react";
  import axios from "axios";
  import CONFIG from "../config";

  // Create Context
  export const PatientContext = createContext();

  // Custom Hook for using Patient Context
  export const usePatient = () => useContext(PatientContext);

  //const token = localStorage.getItem("authToken");

  const createVisitTemplate = (patientId, caseId, visitId, doctorId, clinicId, historyData, actionstatus) => ({
    VISIT_ID: visitId,
    CASE_ID: caseId,
    PATIENT_ID: patientId,
    VISIT_DATE: new Date().toISOString().slice(0, 19).replace("T", " "),
    LAST_UPDATE_DT: new Date().toISOString().slice(0, 19).replace("T", " "),
    LAST_UPDATE_USER: "Doctor",
    DOCTOR_ID: doctorId,
    CLINIC_ID: clinicId,
    ACTION_STATUS: actionstatus
  });

  export const PatientProvider = ({ children }) => {
    const baseURL = CONFIG.BASE_URL;

    const [doctorInfo, setDoctorInfo] = useState({
      MANDALI_ID: null,
      MANDALI_ROLE: null,
      CLINIC_ID: null,
      CLINIC_LIST: [] // ✅ added
    });
    const [patientData, setPatientData] = useState(null);
  // const [selectedPatient, setSelectedPatient] = useState(null);
    const [selectedCase, setSelectedCase] = useState(null);
    const [selectedVisit, setSelectedVisit] = useState(null);
    const [patientCases, setPatientCases] = useState(null);
    const [token, setToken] = useState(localStorage.getItem("authToken"));

    //const token = localStorage.getItem("authToken"); // or from context


  // useEffect (() => {

  //   if(!token) {

  //     setToken(localStorage.getItem("authToken"));

  //   }

  // }, []);


  // Fetch visit for the next Case
    const fetchVisitsForCase = async (patientId, caseId) => {
      try {

  console.log('token in fetch visits for a case', localStorage.getItem("authToken"));
  console.log('doctorInfo in fetch visits for a case', doctorInfo);

  //        const response = await axios.get(`${baseURL}/visits/${patientId}/${caseId}`);
          const response = await axios.get(`${baseURL}/visits/${patientId}/${caseId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,        // 🔐 JWT Token
            doctorId: doctorInfo.MANDALI_ID,       // 🧑‍⚕️ Custom context
            clinicId: doctorInfo.CLINIC_ID,
            roleId: doctorInfo.MANDALI_ROLE
          }
        });

          return response.data; // Ensure it returns data correctly
      } catch (error) {
          console.error("Error fetching visits:", error);
          return [];
      }
  };

  // const response = await axios.get(`${baseURL}/patients/${patient.PATIENT_ID}/cases`, {
  //   headers: {
  //     Authorization: `Bearer ${token}`,        // 🔐 JWT Token
  //     doctorId: doctorInfo.MANDALI_ID,       // 🧑‍⚕️ Custom context
  //     clinicId: doctorInfo.CLINIC_ID,
  //     roleId: doctorInfo.MANDALI_ROLE
  //   }
  // });


  // Fetch patient Visit details
  const fetchPatientData = async (patientId, caseId, visitId) => {
    try {
  //      const response = await axios.get(`${baseURL}/visits/${patientId}/${caseId}/${visitId}`);

  const response = await axios.get(`${baseURL}/visits/${patientId}/${caseId}/${visitId}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('authToken')}`,        // 🔐 JWT Token
      doctorId: doctorInfo.MANDALI_ID,       // 🧑‍⚕️ Custom context
      clinicId: doctorInfo.CLINIC_ID,
      roleId: doctorInfo.MANDALI_ROLE
    }
  });

  //     setPatientInfo(response.data);
        return response.data; // Ensure it returns data correctly

    } catch (error) {
        console.error("Error fetching patient data:", error);
        return null;
    }
  };


    // Fetch next available Case ID
    const fetchNextCaseId = async (patientId) => {
      try {
        const response = await axios.get(`${baseURL}/visits/next-case-id/${patientId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            doctorId: doctorInfo.MANDALI_ID,
            clinicId: doctorInfo.CLINIC_ID,
            roleId: doctorInfo.MANDALI_ROLE
          }
        });
        return response.data.nextCaseId;
      } catch (error) {
        console.error("Error fetching next case ID:", error);
        return null;
      }
    };

    // Fetch next available Visit ID
    const fetchNextVisitId = async (patientId, caseId) => {
      try {
        const response = await axios.get(`${baseURL}/visits/next-visit-id/${patientId}/${caseId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            doctorId: doctorInfo.MANDALI_ID,
            clinicId: doctorInfo.CLINIC_ID,
            roleId: doctorInfo.MANDALI_ROLE
          }
        });
        return response.data.nextVisitId;
      } catch (error) {
        console.error("Error fetching next visit ID:", error);
        return null;
      }
    };

    // Fetch patient history
    const fetchPatientHistory = async (patientId, caseId) => {
      try {
  //     const response = await axios.get(`${baseURL}/patients/getpatienthistory/${patientId}/${caseId}`);
  const response = await axios.get(`${baseURL}/patients/getpatienthistory/${patientId}/${caseId}`, {
    headers: {
      Authorization: `Bearer ${token}`,        // 🔐 JWT Token
      doctorId: doctorInfo.MANDALI_ID,       // 🧑‍⚕️ Custom context
      clinicId: doctorInfo.CLINIC_ID,
      roleId: doctorInfo.MANDALI_ROLE
    }
  });

  return response.data;
      } catch (error) {
        console.error("Error fetching patient history:", error);
        return null;
      }
    };

    // Create a new Visit
    const createNewVisit = useCallback((patientId, caseId, visitId, historyData, actionStatus) => {
      return createVisitTemplate(patientId, caseId, visitId, doctorInfo.doctorId, doctorInfo.clinicId, historyData, actionStatus);
    }, [doctorInfo]);


    
    const updateExistingCaseVisit = async (patientData) => {
        
      if (!patientData) {
          console.error("updateExistingCaseVisit: No patient data provided");
          return;
      }

      try {
          console.log("Updating existing case visit with:", patientData);

          // const response = await axios.put(
          //     `${baseURL}/visits/${patientData.patientInfo.PATIENT_ID}/${patientData.patientSymptoms.CASE_ID}/${patientData.patientSymptoms.VISIT_ID}`,
          //     patientData
          // );

        //   const response = await axios.put(
        //     `${baseURL}/visits/${patientData.patientInfo.PATIENT_ID}/${patientData.patientSymptoms.CASE_ID}/${patientData.patientSymptoms.VISIT_ID}`,
        //     patientData,
        //     { headers: { "Content-Type": "application/json" } } // ✅ Ensure JSON content type
        // ); 

        const response = await axios.put(`${baseURL}/visits/${patientData.patientInfo.PATIENT_ID}/${patientData.patientSymptoms.CASE_ID}/${patientData.patientSymptoms.VISIT_ID}`, 
          patientData, {
          headers: {
            Authorization: `Bearer ${token}`,        // 🔐 JWT Token
            doctorId: doctorInfo.MANDALI_ID,       // 🧑‍⚕️ Custom context
            clinicId: doctorInfo.CLINIC_ID,
            roleId: doctorInfo.MANDALI_ROLE,
            "Content-Type": "application/json"
          }
        });


          console.log("Successfully updated existing case visit:", response.data);
          return response.data;
      } catch (error) {
          console.error("Error updating existing case visit:", error.response ? error.response.data : error.message);
          return null;
      }
  };

  const addNewCaseVisit = async (patientData) => {
    if (!patientData) {
        console.error("addNewCaseVisit: No patient data provided");
        return;
    }

    try {
        console.log("Adding new case visit with:", patientData);

  //      const response = await axios.post(`${baseURL}/visits/addnewcasevisit`, patientData);

  const response = await axios.post(`${baseURL}/visits/addnewcasevisit`, patientData, {
    headers: {
      Authorization: `Bearer ${token}`,        // 🔐 JWT Token
      doctorId: doctorInfo.MANDALI_ID,       // 🧑‍⚕️ Custom context
      clinicId: doctorInfo.CLINIC_ID,
      roleId: doctorInfo.MANDALI_ROLE
    }
  });


        console.log("Successfully added new case visit:", response.data);
        return response.data;
    } catch (error) {
        console.error("Error adding new case visit:", error.response ? error.response.data : error.message);
        return null;
    }
  };

  const addExistingCaseVisit = async (patientData) => {
    if (!patientData) {
        console.error("addExistingCaseVisit: No patient data provided");
        return;
    }

    try {
        console.log("Adding existing case visit with:", patientData);

  //      const response = await axios.post(`${baseURL}/visits/addexistingcasevisit`, patientData);

  const response = await axios.post(`${baseURL}/visits/addexistingcasevisit`, patientData, {
    headers: {
      Authorization: `Bearer ${token}`,        // 🔐 JWT Token
      doctorId: doctorInfo.MANDALI_ID,       // 🧑‍⚕️ Custom context
      clinicId: doctorInfo.CLINIC_ID,
      roleId: doctorInfo.MANDALI_ROLE
    }
  });


        console.log("Successfully added existing case visit:", response.data);
        return response.data;
    } catch (error) {
        console.error("Error adding existing case visit:", error.response ? error.response.data : error.message);
        return null;
    }
  };


  function updateNestedKeys(obj, updates) {
    const result = { ...obj }; // Create a shallow copy of the original object

    // Iterate over each key in the updates object
    for (const key of Object.keys(updates)) {
      // If the target key doesn't exist, initialize it as an empty object
      if (!result[key] || typeof result[key] !== "object") {
        result[key] = {};
      }

      // Merge the updates into the nested object (preserve existing data)
      result[key] = { ...result[key], ...updates[key] };
    }

    return result;
  }

  const contextValue = useMemo(() => ({
    doctorInfo,
    setDoctorInfo,
    selectedCase,
    setSelectedCase,
    selectedVisit,
    setSelectedVisit,
    fetchNextCaseId,
    fetchNextVisitId,
    fetchPatientHistory,
    fetchVisitsForCase, 
    fetchPatientData,
    createNewVisit,
    patientData,
    setPatientData,
    updateExistingCaseVisit,
    addNewCaseVisit,
    addExistingCaseVisit,   
    updateNestedKeys,
    patientCases,
    setPatientCases,
    token,
    setToken
  }), [
    doctorInfo,
    selectedCase,
    selectedVisit,
    setSelectedVisit,
    fetchNextCaseId,
    fetchNextVisitId,
    fetchPatientHistory,
    fetchVisitsForCase, 
    fetchPatientData,
    createNewVisit,
    patientData,
    setPatientData,
    updateExistingCaseVisit,
    addNewCaseVisit,
    addExistingCaseVisit,   
    updateNestedKeys,
    patientCases,
    setPatientCases,
    token,
    setToken
  ]);


    return (
      <PatientContext.Provider
        value={contextValue}
      >
        {children}
      </PatientContext.Provider>
    );
  };

  // {
  //   doctorInfo,
  //   setDoctorInfo,
  // //      selectedPatient,
  // //        setSelectedPatient,
  //   selectedCase,
  //   setSelectedCase,
  //   selectedVisit,
  //   setSelectedVisit,
  //   fetchNextCaseId,
  //   fetchNextVisitId,
  //   fetchPatientHistory,
  //   fetchVisitsForCase, 
  //   fetchPatientData,
  //   createNewVisit,
  //   patientData,
  //   setPatientData,
  //   updateExistingCaseVisit,
  //   addNewCaseVisit,
  //   addExistingCaseVisit,   
  //   updateNestedKeys,
  //   patientCases,
  //   setPatientCases
  // }